export default __webpack_public_path__ + "assets/default.029fdfd5.jpg";